import styled from 'styled-components';

interface ListItemProps {
  isClickable?: boolean;
  isHighlighted?: boolean;
}

export const ListItem = styled.li<ListItemProps>(({ isHighlighted, isClickable, theme }) => ({
  padding: '6px 16px',
  background: isHighlighted ? theme.colors.neutral['100'] : theme.colors.bg,
  cursor: isClickable ? 'pointer' : 'initial',
  userSelect: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: 16,
}));
